<template>
    <el-row>
        <el-col :span="5">
            <h1 class="app-title">Solar App</h1>
        </el-col>
        <el-col :span="13">
            <el-menu
                    :default-active="getActiveRoute()"
                    class="main-nav"
                    mode="horizontal"
                    @select="handleSelect">
                <el-menu-item
                        v-if="user_has_role(['admin', 'sales', 'supplier'])"
                        index="/orders">Bestellungen</el-menu-item>
                <el-menu-item index="/buildings">Gebäude</el-menu-item>

                <el-menu-item
                        v-if="user_is_admin"
                        index="/suppliers">Supplier
                </el-menu-item>
                <el-menu-item
                        v-if="user_is_supplier"
                        index="/supplier">Supplier-Einstellungen
                </el-menu-item>
                <el-menu-item
                        v-if="user_is_admin"
                        index="/users">Benutzer
                </el-menu-item>
                <el-menu-item
                        v-if="user_is_admin || user_is_supplier"
                        index="/wording">Bezeichnungen</el-menu-item>
                <el-menu-item
                        v-if="!user_is_admin"
                        index="/settings">Benutzer-Einstellungen</el-menu-item>

                <!--<el-menu-item index="/options">Optionen</el-menu-item>-->
            </el-menu>
        </el-col>
        <el-col :span="4">
            <el-button
                    class="logout-btn"
                    v-if="is_authenticated"
                    @click.native="logout()"
                    type="info"
                    plain
                    size="mini">
                    Abmelden <i class="el-icon-arrow-right"></i>
            </el-button>
        </el-col>
    </el-row>
</template>

<script>
    /* eslint-disable no-underscore-dangle,no-console */
    import { mapGetters } from 'vuex';
    import { AUTH, RESET_STATE } from '../../store/types';

    export default {
        name: 'dashboard-header',
        computed: {
            ...mapGetters([
                'is_authenticated',
                'user_is_admin',
                'user_is_supplier',
                'user_has_role',
            ]),
        },
        methods: {
            logout () {
                this.$store.dispatch(`${AUTH.namespace}${AUTH.LOGOUT}`).then((resp) => {
                    this.$router.replace(resp.redirectTo);
                    this.$store.commit(RESET_STATE);
                }).catch((err) => {
                    throw err;
                });
            },
            handleSelect (key) {
                this.$router.push(key);
            },
            getActiveRoute () {
                return `/${this.$route.path.split('/')[1]}`;
            },
        },
    };
</script>

<style scoped>

    .app-title{
        line-height: 60px;
        text-align: center;
        vertical-align: middle;
    }
    .logout-btn {
        float: right;
        margin-top: 15px;
    }
</style>



// WEBPACK FOOTER //
// src/components/global/header.vue